import React from 'react';
import useSWRMutation from 'swr/mutation';
import useSWR, { SWRConfiguration } from 'swr';

import { Library } from '../../types/library';
import { GameDocument } from '../../types/game-document';
import { GetAllAsync, GetAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { GameResponse } from '../../types/responses/game-response';
import { GameDocumentVersionResponse } from '../../types/responses/game-document-version-response';

const GamesEndpoint = `games`;
const EventGamesEndpoint = `event/games`;

export const useGetGames = (
  params?: string,
  libraryType?: 'admin' | 'library',
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<GameResponse>
  >(
    `${!libraryType ? '' : libraryType + '/'}${GamesEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetGameLatestDocument = () => {
  const { data, error, isMutating, trigger } = useSWRMutation<
    GameDocument,
    Error,
    string,
    { id: string }
  >(
    'game-document-latest',
    async (_, { arg }) => {
      const document = await GetAsync<GameDocumentVersionResponse>(
        `${GamesEndpoint}/${arg.id}/documents/latest`
      );

      return GetAsync<GameDocument>(
        `${GamesEndpoint}/${arg.id}/document/${document.id}/contents`
      );
    },
    {
      revalidate: false
    }
  );

  return { data, error, isMutating, trigger };
};

export const useGetPublishedGames = (
  params?: string,
  options?: SWRConfiguration
) => {
  const [games, setGames] = React.useState<Library[]>([]);

  const { data, error, isLoading } = useSWR<KendoGridResult<GameResponse>>(
    `${EventGamesEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  React.useEffect(() => {
    if (data) {
      const libs = data.data as Library[];
      const sortedGame = libs.sort((a, b) => {
        const order: { [key: string]: number } = {
          TILO: 0,
          AR: 1,
          VR: 2,
          Game: 3
        };
        return (order[a.type] ?? 99) - (order[b.type] ?? 99);
      });
      setGames(sortedGame);
    }
  }, [data]);

  if (error) console.log(error);

  return {
    games,
    isLoading,
    isError: error
  };
};
